export const SMS_TEXT = 'https://www.apple.com/shop/browse/account/home';

export const SMS_COUNTRY_CODES = [
  { code: '+61', country: 'AUS' }
];

export const MEMBER_TYPES = [
  'school',
  'organization',
  'community',
  'charity'
];

export const COMPANY_TYPES = [
  { name: 'school', title: 'School', pluralName: 'Schools' },
  { name: 'community', title: 'Community', pluralName: 'Communities' },
  { name: 'organization', title: 'Organization', pluralName: 'Organizations' },
  { name: 'charity', title: 'Charity', pluralName: 'Charities' },
];